import { useState } from 'react';
import { VariableDefinition } from '../variable-schema';
import { sanitizeNumericInput, toCanonicalNumber } from '../utils/numeric-input';

interface NumberInputProps {
  def: VariableDefinition;
  value: string | number;
  onChange: (key: string, value: string) => void;
}

export function NumberInput({ def, value, onChange }: NumberInputProps) {
  const [draft, setDraft] = useState<string | null>(null);

  const handleChange = (input: string) => {
    const text = sanitizeNumericInput(input);
    if (text === null) return;

    setDraft(text);

    if (text === '') {
      onChange(def.key, def.emptyValue === undefined ? '0' : '');
      return;
    }

    const committed = toCanonicalNumber(text);
    if (committed !== null) onChange(def.key, committed);
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      className="form-control form-control-sm variable-field__number-input"
      value={draft ?? String(value)}
      placeholder={def.placeholder}
      disabled={!def.editable}
      onChange={(e) => handleChange(e.target.value)}
      onBlur={() => setDraft(null)}
    />
  );
}
